import { Tooltip } from '@cinesend/ui-kit'

/** Shows a tooltip explaining why a control is disabled. Pass no reason to render children as-is. */
const DisabledTooltip = ({ reason, children, className = 'inline-flex max-w-full' }) => {
  if (!reason) return children
  return <Tooltip title={reason} trigger={<span className={className}>{children}</span>} />
}

export default DisabledTooltip
